import * as React from 'react';
import { MailFolderList } from 'owa-mail-folder-view';
import { observer } from 'mobx-react';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import toggleFolderNodeExpansion from 'owa-mail-folder-store/lib/actions/toggleFolderNodeExpansion';
import { logRootFolderNodeClick } from 'owa-mail-folder-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { lazyDeleteFolderInFolderForest } from 'owa-mail-folder-forest-actions';
import { ActionSource } from 'owa-mail-store';
import { isFolderUnderDeletedItemsFolder } from 'owa-mail-store';
import {
    getArchiveMailboxRootFolder,
    getMailboxLoadingState,
    lazyGetArchiveFolders,
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
    ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID,
    Folder,
    ARCHIVE_FOLDERS_TREE_TYPE,
} from 'owa-folders';

const FOLDER_PANE = 'FOLDER_PANE';

export interface ArchiveMailFolderTreeContainerProps {
    className: string;
}

/**
 * Archive mailbox container
 */
function ArchiveMailFolderTreeContainer(props: ArchiveMailFolderTreeContainerProps) {
    const archiveRootFolder = getArchiveMailboxRootFolder();
    const isArchiveRootExpanded = getFolderViewStateFromId(archiveRootFolder.distinguishedFolderId)
        .isExpanded;

    // Archive mailbox root click handler. The getArchiveFolders orchestrator shall fetch the folders
    // only if they are not fetched successfully previously
    const onRootNodeChevronClicked = async () => {
        (await lazyGetArchiveFolders.import())(
            FOLDER_PANE /* Archive mailbox folders loading source */
        );
        toggleFolderNodeExpansion(archiveRootFolder.distinguishedFolderId, true);
        logRootFolderNodeClick(archiveRootFolder.distinguishedFolderId);
    };

    const onDeleteFolder = (folder: Folder, actionSource: ActionSource) => {
        const archiveDeletedItemsFolderId = folderNameToId(ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID);
        const isFolderUnderDeletedItemFolder = isFolderUnderDeletedItemsFolder(
            folder,
            ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID
        );

        lazyDeleteFolderInFolderForest.importAndExecute(
            folder.FolderId.Id,
            actionSource,
            archiveDeletedItemsFolderId,
            isFolderUnderDeletedItemFolder
        );
    };

    return (
        <MailFolderList
            className={props.className}
            key="archivemailboxtree"
            showRootNode={true}
            rootFolder={archiveRootFolder}
            isRootExpanded={isArchiveRootExpanded}
            rootDisplayName={archiveRootFolder.DisplayName}
            childFolderIds={archiveRootFolder.childFolderIds}
            onRootNodeChevronClickedCallback={onRootNodeChevronClicked}
            treeType={ARCHIVE_FOLDERS_TREE_TYPE}
            isFavoritesSupported={false}
            onDeleteFolderCallback={onDeleteFolder}
            loadingState={getMailboxLoadingState(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID)}
        />
    );
}

export default observer(ArchiveMailFolderTreeContainer);
